import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Bell, Home, MapPin } from "lucide-react";
import api from "../../lib/api";
import { EmployerTabs } from "../../components/employer/EmployerTabs";

export default function EmployerNotifications() {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/employer/notifications").then(({ data }) => setData(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const notes = data?.notifications || [];
  const fmt = (d) => (d ? new Date(d).toLocaleDateString(i18n.language) : "");

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="font-heading text-3xl font-bold text-stone-text mb-6">{t("employer.notifications.title")}</h1>
      <EmployerTabs />

      {loading ? (
        <div className="py-12 text-center text-stone-muted">{t("jobs.loading")}</div>
      ) : notes.length === 0 ? (
        <div className="py-12 text-center text-stone-muted" data-testid="enotes-empty">{t("employer.notifications.empty")}</div>
      ) : (
        <div className="space-y-3" data-testid="enotes-list">
          {notes.map((n) => (
            <div key={n.id} className="bg-white rounded-2xl border border-stone-border shadow-sm p-4 flex items-start gap-3" data-testid="enote-item">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${n.housing_match ? "bg-housing/15" : "bg-brand-soft"}`}>
                {n.housing_match ? <Home className="w-5 h-5 text-housing" /> : <Bell className="w-5 h-5 text-brand" />}
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading font-semibold text-stone-text">{n.candidate_name || t("employer.notifications.newRequest")}</h3>
                  <span className="text-xs text-stone-muted shrink-0">{fmt(n.at)}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-stone-sub mt-0.5">
                  <MapPin className="w-3.5 h-3.5" /> {n.city}{n.state ? `, ${n.state}` : ""}
                  {n.housing_match && <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-housing/15 text-housing">{t("employer.notifications.housingMatch")}</span>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
